/*
 * Copyright 2026 Sony Corporation
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { loadConfig } from './config';

const root = createRoot(document.getElementById('root')!);

// Configuration is fetched before the first render so no component has to cope with a half-configured client.
loadConfig().then(
  (config) =>
    root.render(
      <StrictMode>
        <App config={config} />
      </StrictMode>
    ),
  (error: Error) => {
    root.render(<pre style={{ margin: 32, whiteSpace: 'pre-wrap', color: '#f14c4c' }}>{error.message}</pre>);
  }
);
